// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class SearchField extends Vue {
  @Prop({ default: "" })
  public value!: string;

  public onInput(event) {
    this.$emit("input", event);
  }
}
